export function useClipboard() {
    function copy(text) {
        if (navigator.clipboard) {
            return navigator.clipboard.writeText(text);
        } else {
            // If clipboard API isn't available for whatever reason, we can try the old method
            let textArea = document.createElement("textarea");
            textArea.value = text;

            // Make the textarea out of viewport
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            textArea.style.top = "-999999px";

            document.body.appendChild(textArea);

            textArea.focus();
            textArea.select();

            return new Promise((res, rej) => {
                document.execCommand("copy") ? res() : rej();
                textArea.remove();
            });
        }
    }


    return {copy};
}
